import React, { useEffect } from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { CURRENT_LOCALE } from './constants';

export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || window.location.origin;

export const isAbsoluteURL = (url: any) => /^(?:[a-z]+:)?\/\//i.test(url.trim());

export const parseURL = (url: any) => {
  const parser = document.createElement('a');
  parser.href = url;
  const { href, protocol, host, hostname, port, origin, pathname, search, hash } = parser;

  return {
    ...(isAbsoluteURL(url) && {
      href,
      protocol,
      host,
      hostname,
      port,
      origin,
    }),
    pathname,
    search,
    hash,
  };
};

export const smoothScrollToAnchor = (anchor: any) => (event: any) => {
  if (event) event.preventDefault();
  const target = document.querySelector(anchor);
  if (target) {
    const offsetTop = target.getBoundingClientRect().top + window.pageYOffset;
    window.scroll({
      top: offsetTop,
      behavior: 'smooth',
    });
  }
};

function getScrollConfig(targetSelector: any, scrollTop: any) {
  const target = document.querySelector(targetSelector);
  if (!target) return null;

  return {
    behavior: 'smooth',
    top: scrollTop + target.getBoundingClientRect().top - 24, //scroll to the target and leave at least 24 px space above the target
  };
}

export function smoothScrollModalToSelector(targetSelector: any, delay: any) {
  const modal = document.querySelector('.modal');
  if (modal) {
    const scroll = () => {
      const scrollConfig = getScrollConfig(targetSelector, modal.scrollTop);
      // @ts-expect-error ts-migrate(2345) FIXME: manually added
      if (scrollConfig) modal.scroll(scrollConfig);
    };
    if (delay) {
      setTimeout(() => {
        scroll();
      }, delay);
    } else {
      scroll();
    }
  }
}

export function smoothScrollModalToFirstAlert() {
  smoothScrollModalToSelector('.alert', 350);
}

export function useHash(loading: any) {
  const history = useHistory();
  useEffect(() => {
    if (history.location.hash && !loading) {
      setTimeout(() => {
        // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
        smoothScrollToAnchor(history.location.hash)();
      }, 0);
    }
  }, [history.location.hash, loading]);
}

export const redirectIfDifferentLocale = () => {
  const currentLocale = sessionStorage.getItem(CURRENT_LOCALE);
  const [, language, pathRemainder] =
    window.location.href.substring(window.location.origin.length).match(/\/?(.+?)(\/.+)$/) || [];
  if (currentLocale && currentLocale !== language) {
    const correctUrl = `/${currentLocale}${pathRemainder || ''}`;
    return <Redirect to={correctUrl} />;
  }
  return null;
};
